import { Checkbox, Modal } from 'antd';
import { CheckboxChangeEvent } from 'antd/lib/checkbox';
import { Fragment, PureComponent } from 'react';
import { connect } from 'react-redux';
import { ThunkDispatch } from 'redux-thunk';
import { Translate } from '../../api/pushVisit';
import { Actions } from '../../store/actions';
import { updateTranslate } from '../../store/actions/prescriptionPad';
import { GlobalState } from '../../store/reducers';
import { getTranslate } from '../../store/selectors/prescriptionPad';
import { track } from '../../tracking';
import { AntTooltip } from '../common/AntTooltip';
import { previewIcon } from '../common/Icons';
import TranslatedAdvicesList from './TranslatedAdvicesList';

type State = {
    isModalOpen?: boolean;
};

type Props = {
    dispatch: ThunkDispatch<GlobalState, null, Actions>;
    translate: Translate;
};

class AdvicesTranslate extends PureComponent<Props, State> {
    state: State = {
        isModalOpen: false,
    };
    previewIcon = previewIcon('w-16 h-16 fill-actionPrimary');

    closeModal = () => {
        this.setState({
            isModalOpen: false,
        });
    };

    openModal = () => {
        this.setState({
            isModalOpen: true,
        });
    };

    handleChange = (e: CheckboxChangeEvent) => {
        const { translate } = this.props;
        this.props.dispatch(
            updateTranslate({
                ...translate,
                advices: e.target.checked,
                flag: e.target.checked ? true : translate.flag,
            }),
        );
        track('TRANSLATION_OPTION_SELECTED', {
            option: 'advices',
            value: e.target.checked.toString(),
        });
    };

    render() {
        const { isModalOpen } = this.state;
        const { translate } = this.props;
        return (
            <div className="flex space-x-8 items-center select-none">
                <Checkbox onChange={this.handleChange} checked={translate.advices}>
                    Enable Translations
                </Checkbox>
                {translate.advices && (
                    <Fragment>
                        <span onClick={this.openModal}>
                            <AntTooltip content={'Preview translations'} className="cursor-pointer">
                                <span className="flex space-x-4 items-center">
                                    <span>{this.previewIcon}</span> <span> {translate.lang}</span>
                                </span>
                            </AntTooltip>
                        </span>
                        <Modal
                            title="Advices"
                            visible={isModalOpen}
                            onOk={this.closeModal}
                            onCancel={this.closeModal}
                            cancelButtonProps={{ className: 'hidden' }}
                            destroyOnClose
                            width={800}
                            bodyStyle={{ height: 400, width: 800, overflow: 'hidden' }}
                        >
                            <TranslatedAdvicesList />
                        </Modal>
                    </Fragment>
                )}
            </div>
        );
    }
}

export default connect((state: GlobalState) => ({
    translate: getTranslate(state),
}))(AdvicesTranslate);
